<a
  class="brand"
  routerLink="/home"
  [attr.aria-label]="appName"
  (click)="linkClicked()"
>
  <img class="brand-logo brand-logo-full" [src]="logo.full" alt="" />
  <img class="brand-logo brand-logo-small" [src]="logo.mark" alt="" />
  <span class="brand-name">{{ appName }}</span>
</a>

<nav class="side-nav" [attr.aria-label]="'common.nav.sidebar' | translate">
  <ul class="nav-list">
    @for (link of mainLinks; track link.link) {
      <li>
        <ng-container
          [ngTemplateOutlet]="navLink"
          [ngTemplateOutletContext]="{ $implicit: link }"
        ></ng-container>
      </li>
    }
  </ul>
</nav>

<div class="side-menu-lists">
  @for (item of menu; track item) {
    <section class="side-menu-section">
      <button
        type="button"
        class="nav-link rail-section-button"
        [title]="item.name | translate"
        [attr.aria-label]="item.name | translate"
        (click)="expandSidebar()"
      >
        <i class="nav-icon" [ngClass]="item.icon || ''" aria-hidden="true"></i>
      </button>
      <app-action-list
        [id]="item.id"
        [name]="item.name"
        [icon]="item.icon || null"
        [items]="item.list"
        [limitItems]="item.limit || null"
        [moreLink]="item.more || null"
        [emptyText]="item.emptyText || null"
        (itemClicked)="listItemClicked(item.id, $event)"
        (moreClicked)="linkClicked()"
      ></app-action-list>
    </section>
  }
</div>
@if (adminLinks.length) {
  <nav
    class="side-nav admin-nav"
    [attr.aria-label]="'common.nav.admin' | translate"
  >
    <div class="nav-group-title">
      <span class="nav-label">{{ 'common.nav.admin' | translate }}</span>
    </div>
    <ul class="nav-list">
      @for (link of adminLinks; track link.link) {
        <li>
          <ng-container
            [ngTemplateOutlet]="navLink"
            [ngTemplateOutletContext]="{ $implicit: link }"
          ></ng-container>
        </li>
      }
    </ul>
  </nav>
}

<ng-template #navLink let-link>
  <a
    class="nav-link"
    [routerLink]="link.link"
    routerLinkActive="nav-link-active"
    ariaCurrentWhenActive="page"
    [routerLinkActiveOptions]="{ exact: !!link.exact }"
    [title]="link.label | translate"
    (click)="linkClicked()"
  >
    <i class="nav-icon fa-solid" [ngClass]="link.icon" aria-hidden="true"></i>
    <span class="nav-label">{{ link.label | translate }}</span>
    @if (link.alerts) {
      @let unread = (unreadAlerts$ | async) || 0;
      @if (unread) {
        <span
          class="nav-badge"
          [attr.aria-label]="
            'common.nav.unreadAlerts' | translate: { count: unread }
          "
          >{{ unread }}</span
        >
      }
    }
  </a>
</ng-template>
